import { fn, hash } from '@ember/helper';
import type { EmberChangeset } from 'ember-changeset';
import FeelingEvasSectionContent from 'parog-web/components/feeling-evas/sliders/component';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import fuiSlider from 'wise-fui-modules/modifiers/fui-slider';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    key: string;
    form: { changeset: EmberChangeset };
    forcComponent: ForcJournalEventBasedComponent;
  };
  Blocks: {
    header: [];
    highest: [];
    lowest: [];
  };
}

export default class SliderComponent extends FeelingEvasSectionContent<Signature> {
  get value(): number {
    const existingValue = this.args.form.changeset.get(this.args.key);
    return existingValue ? Number(existingValue) : 0;
  }

  onChange = (value: number) => {
    this.args.form.changeset.set(this.args.key, value.toString());
  };

  <template>
    <div class='flex flex-col gap-8'>
      {{yield to='header'}}

      {{! prettier-ignore }}
      <div data-test-slider={{@key}}>
        <div class='ui labeled ticked primary slider {{if @forcComponent.isReadOnly "disabled"}}'
          ...attributes
          {{fuiSlider min=0 max=10 step=1 start=this.value onChange=this.onChange autoAdjustLabels=false interpretLabel=(fn this.labels (hash 0="<i class='smile outline large green icon mb-2'></i>" 10="<i class='flushed tear outline red large icon mb-2'></i>" ) ) }}
        ></div>

        <div class='flex justify-between'>
          <span class='ui small text-black'>
            {{yield to='lowest'}}
          </span>
          <span class='ui small text-right text-black'>
            {{yield to='highest'}}
          </span>
        </div>
      </div>
    </div>
  </template>
}
